import { Dayjs } from 'dayjs';
import { SetStateAction } from 'react';
import { ISODate } from '../utils';

export type MonthIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
export const MONTHS = [...Array(12).keys()] as MonthIndex[];

export interface Day {
  date: Dayjs;
  dateStr: ISODate;
  isCurrentMonth: boolean;
  isHoliday: boolean;
}
export type Week = Day[];
export interface Month {
  month: MonthIndex;
  name: string;
  weeks: Week[];
}

export interface Holiday {
  dayOfMonth: number;
  month: MonthIndex;
  year?: number;
}

export interface CalendarCommonProps {
  holidays: Holiday[];
  period: Dayjs;
  selected: Set<string>;
  setSelected: (selected: SetStateAction<Set<ISODate>>) => void;
}

export const MONTH_VIEW = 'month';
export const YEAR_VIEW = 'year';
export type ViewType = typeof MONTH_VIEW | typeof YEAR_VIEW;
